import { Modal as ModalAntd } from 'antd'
import { ModalProps } from 'antd/lib'

import { Close } from './Icons'

const Modal = ({ ...props }: ModalProps) => {
  return (
    <ModalAntd
      className="[&_.ant-modal-header]:pr-4"
      closeIcon={<Close className="stroke-gray-600" />}
      width={{
        xs: '90%',
        sm: '80%',
        md: '70%',
        lg: '60%',
        xl: '50%',
        xxl: '40%',
      }}
      {...props}
    />
  )
}

export default Modal
